import { QUERY_KEYS } from "@/common/query-keys";
import { fetchLocationAssetsPage } from "@/lib/snipeit/hardware";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

export interface LocationAssetsPageParams {
  locationId: number | undefined;
  limit: number;
  offset: number;
  sort: string;
  order: "asc" | "desc";
  search?: string;
  modelId?: number;
  categoryId?: number;
}

/**
 * Fetches a single page of assets for a location with server-side
 * sorting, filtering, and pagination.
 */
export function useLocationAssetsPage(params: LocationAssetsPageParams) {
  const { locationId, limit, offset, sort, order, search, modelId, categoryId } = params;

  return useQuery({
    queryKey: [
      QUERY_KEYS.locationAssetsPage,
      locationId,
      limit,
      offset,
      sort,
      order,
      search ?? "",
      modelId ?? "",
      categoryId ?? "",
    ],
    queryFn: () =>
      fetchLocationAssetsPage({
        locationId: locationId!,
        limit,
        offset,
        sort,
        order,
        search: search || undefined,
        modelId,
        categoryId,
        statusType: "deployable",
      }),
    enabled: locationId !== undefined,
    staleTime: 30_000,
    placeholderData: keepPreviousData,
  });
}
